var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 7 14.4 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "inherit",
    fill: "none",
    transform: "translate(1 1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M12.2 16c4.69 0 7.2 1.597 7.2 4.8a.6.6 0 0 1-1.2 0c0-2.397-1.89-3.6-6-3.6s-6 1.203-6 3.6a.6.6 0 1 1-1.2 0c0-3.203 2.51-4.8 7.2-4.8zm0-9a4.2 4.2 0 1 1 0 8.4 4.2 4.2 0 0 1 0-8.4zm0 1.238a2.962 2.962 0 1 0 0 5.924 2.962 2.962 0 0 0 0-5.924z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.003ed7952858c57b95965fd73ac3b4af.svg";
export { ForwardRef as ReactComponent };